import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { DvlaLookupService } from './dvla-lookup.service';

angular.module('app-lite.dvla-lookup', [])
  .service('dvlaLookupApi', downgradeInjectable(DvlaLookupService));
